import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import PageHeader from '../../components/PageHeader';
import InsuranceDetailsForm from './components/insuranceCompany';
import MedicalReferralInformation from './components/medicalReferralInformation';
import PartnerInformationForm from './components/partnerInformation';
import BasicDetails from './components/basicDetails';
import {
  createPatientApi,
  uploadPatientFileApi,
  getPatientDetailsApi,
  updatePatientApi,
  createPatientPdfApi,
  checkFileAvailabilityApi,
  updateFileStatusUploaded,
  getUniquePatientIdApi,
} from '../../api/patientApi';
import { toast } from 'sonner';
import { useNavigate, useParams } from 'react-router-dom';
import FileDocumentCard from '../../components/FileManager/FileDocumentCard';
import FileUploadCard from '../../components/FileManager/FileUploadCard';
import LoadingOverlay from '../../components/LoadingOverlay';
import { deleteFileApi } from '../../api/fileApi';
import { pollFileAvailability } from '../../api/utils';
import ProtectedComponent from '../../common/ProtectedComponent';
import {
  permissionsList,
  permissionsWithAssignedIds,
} from '../../api/constant';

const RegistrationForm = () => {
  const [submeet, setSubmeet] = useState(false);
  const [patientRegistered, setPatientRegistered] = useState(false);
  const [isEditPatientForm, setIsEditPatientForm] = useState(false);
  const [files, setFiles] = useState([]);
  const [patientId, setPatientId] = useState(null);
  const [useCustomPatientId, setUseCustomPatientId] = useState(false);
  const initialPatientFormData = {
    customPatientId: null,
    upid: '',
    basicDetails: {
      firstName: '',
      lastName: '',
      middleName: '',
      adressName: '',
      adharNumber: '',
      isNRI: false,
      passportNumber: '',
      CityName: '',
      StateName: '',
      country: '',
      zip: '',
      gender: 'male',
      phoneNumber: '',
      homePhone: '',
      occupation: '',
      employerAddress: '',
      emailAddress: '',
      dob: '',
      maritalStatus: 'Single',
      preferredLanguage: '',
      Race: '',
      Ethnicity: '',
      tempAddress: '',
      tempCityName: '',
      tempStateName: '',
      tempAddrSameAsPermanent: false,
      tempzip: '',
      tempCountry: '',
      age: '',
      registeredDate: null,
    },
    guarantorInformation: {
      isGuarantor: 'yes',
      patientName: '',
      patientAddress: '',
      patientCity: '',
      patientPhone: '',
      patientRelation: '',
    },
    partnerInformation: {
      PartnerFirstName: '',
      PartnerMiddleName: '',
      PartnerLastName: '',
      PartnerOccupation: '',
      PartnerEmail: '',
      PartnerAddress: '',
      gender: 'male',
      maritalStatus: 'Single',
      dob: '',
      PartnerEmergency: '',
      EmergencyAddress: '',
      CityName: '',
      StateName: '',
      adharNumber: '',
      isNRI: false,
      passportNumber: '',
      zip: '',
      country: '',
      homePhone: '',
      phone: '',
      occupation: '',
      preferredLanguage: '',
      age: '',
      relationWithPatient: '',
      partnerAddrSameAsSelf: false,
    },
    medicalInformation: {
      referralSource: 'Physician',
      referringPhysician: '',
      referringPhysicianPhone: '',
      referringPhysicianAddress: '',
    },
    insuranceDetails: {
      InsuranceCompany: '',
      PolicyNumber: '',
      GroupNumber: '',
      ClaimAddress: '',
      InsuranceCity: '',
      InsuranceState: '',
      InsuranceZip: '',
      Insurancephone: '',
      relationship: 'Self',
      sub: '',
      relationshipOther: '',
    },
  };
  const [patientFormData, setPatientFormData] = useState(
    initialPatientFormData,
  );
  const [touchedFields, setTouchedFields] = useState({
    adharNumber: false,
    emailAddress: false,
    phoneNumber: false,
    zip: false,
    partnerAdharNumber: false,
    partnerPhoneNumber: false,
    partnerZip: false,
  });

  const navigate = useNavigate();
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const { id: patientIdFromParams } = useParams();
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('');

  useEffect(() => {
    document.body.classList.remove(
      'theme-cyan',
      'theme-purple',
      'theme-blue',
      'theme-green',
      'theme-orange',
      'theme-blush',
    );
  }, []);

  const validateBasicDetails = () => {
    const {
      firstName,
      lastName,
      address,
      adharNumber,
      phoneNumber,
      emailAddress,
      CityName,
      StateName,
      zip,
    } = patientFormData.basicDetails;
    return (
      firstName &&
      lastName &&
      address &&
      CityName &&
      StateName &&
      zip &&
      adharNumber &&
      phoneNumber &&
      emailAddress
    );
  };

  const validatePartnerInformationForm = () => {
    const {
      PartnerFirstName,
      PartnerLastName,
      PartnerAddress,
      adharNumber,
      CityName,
      StateName,
      zip,
      phone,
      relationWithPatient,
    } = patientFormData.partnerInformation;
    return (
      PartnerFirstName &&
      PartnerLastName &&
      PartnerAddress &&
      adharNumber &&
      CityName &&
      StateName &&
      zip &&
      phone &&
      relationWithPatient
    );
  };

  const validateInsuranceDetailsForm = () => {
    const {
      InsuranceCompany,
      PolicyNumber,
      GroupNumber,
      ClaimsAddress,
      InsuranceCity,
      InsuranceState,
      InsuranceZip,
      Insurancephone,
    } = patientFormData.insuranceDetails;
    return (
      InsuranceCompany &&
      PolicyNumber &&
      GroupNumber &&
      ClaimsAddress &&
      InsuranceCity &&
      InsuranceState &&
      InsuranceZip &&
      Insurancephone
    );
  };

  const isFormValid = () => {
    const {
      firstName,
      lastName,
      adharNumber,
      emailAddress,
      dob,
      phoneNumber,
      address,
      CityName,
      StateName,
      zip,
    } = patientFormData.basicDetails;

    const {
      PartnerFirstName,
      PartnerLastName,
      phone,
      relationWithPatient,
      PartnerAddress,
    } = patientFormData.partnerInformation;

    const phoneNumbers = [phoneNumber, phone];

    const fieldsToValidate = [
      { value: firstName, maxLength: 50, isRequired: true },
      { value: lastName, maxLength: 50, isRequired: true },
      { value: relationWithPatient, maxLength: 50, isRequired: true },
      { value: adharNumber, maxLength: 12, isRequired: true, exactLength: 12 },
      {
        value: patientFormData.partnerInformation.zip,
        isRequired: true,
        isNumber: true,
      },
      { value: PartnerAddress, maxLength: 50, isRequired: true },
      {
        value: patientFormData.partnerInformation.CityName,
        maxLength: 50,
        isRequired: true,
      },
      {
        value: patientFormData.partnerInformation.StateName,
        maxLength: 50,
        isRequired: true,
      },

      { value: PartnerFirstName, maxLength: 50, isRequired: true },
      { value: PartnerLastName, maxLength: 50, isRequired: true },
      { value: emailAddress, maxLength: 50, isRequired: true },
      { value: dob, isRequired: true },
      {
        value: patientFormData.partnerInformation.adharNumber,
        maxLength: 12,
        isRequired: true,
        exactLength: 12,
      },
      { value: zip, isRequired: true, isNumber: true },
      { value: address, maxLength: 50, isRequired: true },
      { value: CityName, maxLength: 50, isRequired: true },
      { value: StateName, maxLength: 50, isRequired: true },
    ];

    const areFieldsValid = fieldsToValidate.every(
      ({ value, maxLength, isRequired, exactLength, isNumber }) => {
        const validExactLength =
          !exactLength || validateExactLength(value, exactLength);
        const validNumber = !isNumber || validateIsNumber(value);

        return (
          (!isRequired || value.trim() !== '') &&
          (value.trim() === '' || !validateField(value, maxLength).isInvalid) &&
          validExactLength &&
          validNumber
        );
      },
    );

    const phoneValid = phoneNumbers.every(validatePhoneNumber);

    const emailValid = validateEmail(emailAddress);

    return areFieldsValid && phoneValid && emailValid;
  };

  const validateField = (fieldValue, maxLength) => {
    const isInvalid = fieldValue?.length > maxLength;
    return {
      isInvalid,
      errorMessage: isInvalid ? `Must not exceed ${maxLength} characters.` : '',
    };
  };

  const validateExactLength = (value, exactLength) =>
    value.trim().length === exactLength;

  const validateIsNumber = (value) => /^[0-9]+$/.test(value.trim());

  const validatePhoneNumber = (phone) => {
    const phoneRegex =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
    return phoneRegex.test(phone);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // const isValidNumber = (phoneNumber) => {
  //   const regex = /^(?:\+91|91)?[6-9]\d{9}$/;
  //   return regex.test(phoneNumber.trim());
  // };
  // const validateNumbers = () => {
  //   const { phoneNumber: ph1, homePhone: hp1 } = patientFormData.basicDetails;
  //   const { phone: ph2, homePhone: hp2 } = patientFormData.partnerInformation;

  //   const cellPhonesValid = isValidNumber(ph1) && isValidNumber(ph2);
  //   console.log('ph1', ph1, isValidNumber(ph1), 'ph2', ph2, isValidNumber(ph2));

  //   let homePhonesValid = true;
  //   // if (hp1) {
  //   //   homePhonesValid = isValidNumber(hp1);
  //   // }
  //   // if (hp2) {
  //   //   homePhonesValid = isValidNumber(hp2);
  //   // }
  //   return cellPhonesValid && homePhonesValid;
  // };

  const validateCustomId = () => {
    const { customPatientId } = patientFormData;
    return customPatientId ? !!customPatientId : true;
  };

  const validateAllFields = () => {
    return (
      validateBasicDetails() &&
      validatePartnerInformationForm() &&
      validateCustomId()
      // validateInsuranceDetailsForm()
    );
  };

  const createPatientPayload = (state) => {
    return {
      patientDetails: {
        upid: state.basicDetails.upid || state.upid,
        externalPatientId: useCustomPatientId ? state.customPatientId : null,
        firstName: state.basicDetails.firstName,
        middleName: state.basicDetails.middleName,
        lastName: state.basicDetails.lastName,
        email: state.basicDetails.emailAddress,
        isNRI: state.basicDetails.isNRI,
        passportNumber:
          state.basicDetails.passportNumber === ''
            ? null
            : state.basicDetails.passportNumber,
        address: state.basicDetails.address,
        tempAddress: state.basicDetails.tempAddrSameAsPermanent
          ? state.basicDetails.address
          : state.basicDetails.tempAddress,
        tempCity: state.basicDetails.tempAddrSameAsPermanent
          ? state.basicDetails.CityName
          : state.basicDetails.tempCityName,
        tempState: state.basicDetails.tempAddrSameAsPermanent
          ? state.basicDetails.StateName
          : state.basicDetails.tempStateName,
        tempZip: state.basicDetails.tempAddrSameAsPermanent
          ? state.basicDetails.zip
          : state.basicDetails.tempzip,
        tempCountry: state.basicDetails.tempAddrSameAsPermanent
          ? state.basicDetails.country
          : state.basicDetails.tempCountry,
        tempAddrSameAsPermanent: state.basicDetails.tempAddrSameAsPermanent,
        homePhone: state.basicDetails.homePhone,
        adharNumber: state.basicDetails.adharNumber,
        gender: state.basicDetails.gender,
        phone: state.basicDetails.phoneNumber,
        dob: state.basicDetails.dob,
        age: state.basicDetails.age,
        preferredLanguage: state.basicDetails.preferredLanguage,
        maritalStatus: state.basicDetails.maritalStatus,
        race: state.basicDetails.Race,
        ethnicity: state.basicDetails.Ethnicity,
        isSelfGuarantor: state.guarantorInformation.isGuarantor === 'yes',
        locationDetails: {
          city: state.basicDetails.CityName,
          state: state.basicDetails.StateName,
          zip: state.basicDetails.zip,
          country: state.basicDetails.country,
        },
        companyDetails: {
          name: state.basicDetails.employerAddress,
          occupation: state.basicDetails.occupation,
          email: state.basicDetails.emailAddress, // Assuming employer email is the same as patient's email
        },
        partnerDetails: {
          firstName: state.partnerInformation.PartnerFirstName,
          lastName: state.partnerInformation.PartnerLastName,
          middleName: state.partnerInformation.PartnerMiddleName,
          occupation: state.partnerInformation.occupation,
          email: state.partnerInformation.PartnerEmail,
          isNRI: state.partnerInformation.isNRI,
          passportNumber:
            state.partnerInformation.passportNumber === ''
              ? null
              : state.partnerInformation.passportNumber,
          address: state.partnerInformation.partnerAddrSameAsSelf
            ? state.basicDetails.address
            : state.partnerInformation.PartnerAddress,
          gender: state.partnerInformation.gender,
          dob: state.partnerInformation.dob,
          age: state.partnerInformation.age,
          phone: state.partnerInformation.phone,
          homePhone: state.partnerInformation.homePhone,
          adharNumber: state.partnerInformation.adharNumber,
          preferredLanguage: state.partnerInformation.preferredLanguage,
          locationDetails: {
            city: state.partnerInformation.partnerAddrSameAsSelf
              ? state.basicDetails.CityName
              : state.partnerInformation.CityName,
            state: state.partnerInformation.partnerAddrSameAsSelf
              ? state.basicDetails.StateName
              : state.partnerInformation.StateName,
            zip: state.partnerInformation.partnerAddrSameAsSelf
              ? state.basicDetails.zip
              : state.partnerInformation.zip,
            country: state.partnerInformation.partnerAddrSameAsSelf
              ? state.basicDetails.country
              : state.partnerInformation.country,
          },
          maritalStatus: state.partnerInformation.maritalStatus,
          relationWithPatient: state.partnerInformation.relationWithPatient,
          partnerAddrSameAsSelf: state.partnerInformation.partnerAddrSameAsSelf,
        },
        // guarantorDetails: {
        //   name: state.guarantorInformation.patientName,
        //   phoneNumber: state.guarantorInformation.patientPhone,
        //   address: state.guarantorInformation.patientAddress,
        //   city: state.guarantorInformation.patientCity,
        //   relationship: state.guarantorInformation.patientRelation,
        // },
        referralDetails: {
          referringPhysician: state.medicalInformation.referringPhysician,
          referringPhysicianPhone:
            state.medicalInformation.referringPhysicianPhone,
          referringPhysicianAddress:
            state.medicalInformation.referringPhysicianAddress,
          appliedThrough: state.medicalInformation.referralSource,
        },
        insuranceDetails: {
          companyName: state.insuranceDetails.InsuranceCompany,
          policyNumber: state.insuranceDetails.PolicyNumber,
          groupNumber: state.insuranceDetails.GroupNumber,
          claimAddress: state.insuranceDetails.ClaimAddress,
          city: state.insuranceDetails.InsuranceCity,
          state: state.insuranceDetails.InsuranceState,
          zip: state.insuranceDetails.InsuranceZip,
          phoneNumber: state.insuranceDetails.Insurancephone,
          relationshipToSubscriber: state.insuranceDetails.relationship,
          subscriberName: state.insuranceDetails.sub,
          policyType: state.insuranceDetails.policyType,
          relationshipOther: state.insuranceDetails.relationshipOther,
        },
      },
    };
  };

  useEffect(() => {
    console.log('Patient ID from params:', patientIdFromParams);

    if (patientIdFromParams) {
      setIsEditPatientForm(true);
      setLoading(true);
      setLoadingText('Fetching patient details...');
      getPatientDetailsApi(patientIdFromParams)
        .then((response) => {
          const { patient, patientFiles } = response.data;
          setPatientFormData({
            upid: patient.upid || '',
            basicDetails: {
              firstName: patient.firstName || '',
              lastName: patient.lastName || '',
              middleName: patient.middleName || '',
              address: patient.address || '',
              adharNumber: patient.adharNumber || '',
              CityName: patient.location?.city || '',
              StateName: patient.location?.state || '',
              country: patient.location?.country || '',
              isNRI: patient.isNRI || false,
              passportNumber: patient.passportNumber || '',
              zip: patient.location?.zip || '',
              gender: patient.gender || '',
              phoneNumber: patient.phone || '',
              homePhone: patient.homePhone || '',
              occupation: patient.company?.occupation || '',
              employerAddress: patient.company?.name || '',
              emailAddress: patient.email || '',
              dob: patient.dob || '',
              age: patient.age || '',
              maritalStatus: patient.maritalStatus || 'Single',
              preferredLanguage: patient.preferredLanguage || '',
              Race: patient.race || '',
              Ethnicity: patient.ethnicity || '',
              tempAddress: patient.tempAddress || '',
              profileImage: patient.profileImageId || '',
              tempCityName: patient.tempCity || '',
              tempStateName: patient.tempState || '',
              tempzip: patient.tempZip || '',
              tempCountry: patient.tempCountry || '',
              tempAddrSameAsPermanent: patient.tempAddrSameAsPermanent || false,
              profileImagePresignedUrl: patient.profileImagePresignedUrl || '',
              registeredDate: patient.registeredDate || null,
            },
            guarantorInformation: {
              isGuarantor: patient.isSelfGuarantor ? 'yes' : 'no',
              patientName: patient.guarantor?.name || '',
              patientAddress: patient.guarantor?.address || '',
              patientCity: patient.guarantor?.city || '',
              patientPhone: patient.guarantor?.phoneNumber || '',
              patientRelation: patient.guarantor?.relationship || '',
            },
            partnerInformation: {
              PartnerFirstName: patient.partner?.firstName || '',
              PartnerMiddleName: patient.partner?.middleName || '',
              PartnerLastName: patient.partner?.lastName || '',
              PartnerOccupation: patient.partner?.occupation || '',
              PartnerEmail: patient.partner?.email || '',
              PartnerAddress: patient.partner?.address || '',
              dob: patient.partner?.dob || '',
              PartnerEmergency: patient.partner?.phone || '',
              EmergencyAddress: patient.partner?.adharNumber || '',
              CityName: patient.partner?.location?.city || '',
              country: patient.partner?.location?.country || '',
              StateName: patient.partner?.location?.state || '',
              adharNumber: patient.partner?.adharNumber || '',
              isNRI: patient.partner?.isNRI || false,
              passportNumber: patient.partner?.passportNumber || '',
              zip: patient.partner?.location?.zip || '',
              homePhone: patient.partner?.homePhone || '',
              phone: patient.partner?.phone || '',
              occupation: patient.partner?.occupation || '',
              maritalStatus: patient.partner?.maritalStatus || 'Single',
              preferredLanguage: patient.partner?.preferredLanguage || '',
              gender: patient.partner?.gender || 'male',
              age: patient.partner?.age || '',
              relationWithPatient: patient.partner?.relationWithPatient || '',
              partnerAddrSameAsSelf:
                patient.partner?.partnerAddrSameAsSelf || false,
              profileImagePresignedUrl: patient.partnerProfileImagePresignedUrl,
            },
            medicalInformation: {
              referralSource: patient.referral?.appliedThrough || '',
              referringPhysician: patient.referral?.referringPhysician || '',
              referringPhysicianPhone:
                patient.referral?.referringPhysicianPhone || '',
              referringPhysicianAddress:
                patient.referral?.referringPhysicianAddress || '',
            },
            insuranceDetails: {
              InsuranceCompany: patient.insurance?.companyName || '',
              PolicyNumber: patient.insurance?.policyNumber || '',
              GroupNumber: patient.insurance?.groupNumber || '',
              ClaimAddress: patient.insurance?.claimAddress || '',
              InsuranceCity: patient.insurance?.city || '',
              InsuranceState: patient.insurance?.state || '',
              InsuranceZip: patient.insurance?.zip || '',
              Insurancephone: patient.insurance?.phoneNumber || '',
              policyType: patient.insurance?.policyType || '',
              relationship: patient.insurance?.relationshipToSubscriber || '',
              sub: patient.insurance?.subscriberName || '',
              relationshipOther: patient.insurance?.relationshipOther || '',
            },
            files: patientFiles.map((file) => ({
              id: file.id,
              fileId: file.fileId,
              uploadedAt: file.uploadedAt,
              fileTag: file.fileTag,
              fileTitle: file.fileTitle,
              presignedUrl: file.file.presignedUrl,
            })),
          });
          setUploadedFiles(patientFiles.map((patientFile) => patientFile.file));
          setPatientId(patientIdFromParams);
          setIsEditPatientForm(true);
          setLoading(false);
          setLoadingText('');
        })
        .catch((error) => {
          console.error('Error fetching patient details:', error);
          setLoading(false);
          setLoadingText('');
        });
    } else {
      const getUniqueId = async () => {
        const response = await getUniquePatientIdApi();
        setIsEditPatientForm(false);
        setPatientFormData({
          ...initialPatientFormData,
          upid: response.data.patientId,
        });
        setPatientId(null);
        setUploadedFiles([]);
      };
      getUniqueId();
    }

    return () => {
      setPatientFormData(initialPatientFormData);
      setIsEditPatientForm(false);
      setPatientRegistered(false);
      setPatientId(null);
    };
  }, [patientIdFromParams]);

  const handleSubmit = async () => {
    setSubmeet(false);

    if (files.length === 0) navigate('/view-patients');
    navigate('/view-patients');
  };

  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleUpload = async (file, patientId) => {
    if (!patientId) return toast.error('Patient not created');

    return new Promise((resolve, reject) => {
      try {
        setLoading(true);
        setLoadingText('Uploading...');
        toast.promise(
          uploadPatientFileApi(
            file,
            patientId,
            'Patient',
            updateFileStatusUploaded,
          ),
          {
            loading: 'Uploading file...',
            success: (data) => {
              setUploadedFiles([...uploadedFiles, data]);
              setLoading(false);
              return resolve(data);
            },
            error: (err) => {
              reject('Failed to upload docs');
            },
            duration: 800,
          },
        );
      } catch (err) {
        setLoading(false);
        setLoadingText('');
        toast.error('Failed to upload file');
      }
    });
  };

  const handlePatientRegister = async () => {
    console.log('Patient form data:', patientFormData);
    //[TODO] fix this!!!!!
    if (true) {
      if (false) {
        toast.warning('Phone numbers are invalid');
        return;
      }
      const patientPayload = createPatientPayload(patientFormData);
      console.log(patientPayload);
      const apiCall = patientId
        ? updatePatientApi(patientId, patientPayload)
        : createPatientApi(patientPayload);

      toast.promise(apiCall, {
        loading: patientId ? 'Updating patient...' : 'Creating patient...',
        success: (data) => {
          if (!patientId) {
            setPatientId(data.data.patientId);
          } else {
            console.log('Patient updated successfully!');
          }
          setPatientRegistered(true);
          setIsEditPatientForm(true);
          navigate(`/patient/${data.data.patientId}/edit`, { replace: true });
          return patientId
            ? 'Patient updated successfully!'
            : 'Patient created successfully!';
        },
        error: (err) => {
          setIsSubmitDisabled(false);
          setPatientRegistered(false);
          setIsEditPatientForm(false);
          // return 'Failed to save patient';
          // console.log('err', err.response.data.message);
          if (
            err &&
            err.response &&
            err.response.data &&
            err.response.data.message &&
            typeof err.response.data.message === 'string'
          ) {
            console.log('hehehe', err.response.data.message);

            return err.response.data.message;
          } else if (err.response.data.message.length > 0) {
            return err.response.data.message[0].message;
          }
          return 'Failed to save patient';
        },
        duration: 800,
      });
    } else {
      setSubmeet(true);
      toast.warning('Required fields are missing');
      console.log('Validation failed');
    }
  };

  const prefillForm = () => {
    setPatientFormData((prev) => ({
      basicDetails: {
        upid: prev.upid,
        firstName: 'John',
        middleName: 'Doe',
        lastName: 'Doe',
        address: '123 Main St',
        adharNumber: '123456789012',
        CityName: 'Metropolis',
        tempCityName: 'Metropolis',
        isNRI: false,
        passportNumber: '123123',
        StateName: 'NY',
        tempStateName: 'NY',
        tempCountry: 'USA',
        country: 'USA',
        tempzip: '12345',
        zip: '12345',

        age: '30',

        gender: 'male',
        phoneNumber: '+919424599222',
        homePhone: '+919424599222',

        occupation: 'Engineer',
        employerAddress: '456 Elm St',
        emailAddress: 'john.doe@example.com',
        tempAddress: 'john.doe@example.com',

        dob: '1990-01-01',
        maritalStatus: 'Single',
        preferredLanguage: 'English',
        Race: 'Caucasian',
        Ethnicity: 'Non-Hispanic',
        registeredDate: new Date(),
      },
      guarantorInformation: {
        isGuarantor: 'yes',
        patientName: 'Jane Doe',
        patientAddress: '789 Oak St',
        patientCity: 'Gotham',
        patientPhone: '0987654321',
        patientRelation: 'Spouse',
      },
      partnerInformation: {
        PartnerFirstName: 'Jane Doe',
        age: '30',
        occupation: 'Engineer',
        preferredLanguage: 'English',
        adharNumber: '123456789012',
        PartnerMiddleName: 'Jane Doe',
        StateName: 'NY',
        zip: '12345',
        PartnerLastName: 'Jane Doe',
        CityName: 'Metropolis',
        PartnerOccupation: 'Tech Corp',
        PartnerEmail: 'jane.doe@example.com',
        PartnerAddress: '789 Oak St',
        maritalStatus: 'Single',
        gender: 'female',
        country: 'USA',
        isNRI: false,
        passportNumber: '123123',
        homePhone: '+919424599223',
        phone: '7567890012',
        dob: '1992-02-02',
        PartnerEmergency: '1122334455',
        EmergencyAddress: '789 Oak St',
        relationWithPatient: 'Spouse',
      },
      medicalInformation: {
        referralSource: 'Physician',
        referringPhysician: 'Dr. Smith',
        referringPhysicianPhone: '1231231234',
        referringPhysicianAddress: '101 Medical St',
      },
      insuranceDetails: {
        InsuranceCompany: 'HealthCare Inc.',
        PolicyNumber: 'POL123456',
        GroupNumber: 'GRP123456',
        sub: 'John Doe',
        ClaimsAddress: '202 Insurance Ave',
        InsuranceCity: 'Metropolis',
        InsuranceState: 'NY',
        InsuranceZip: '12345',
        Insurancephone: '5555555555',
        policyType: 'Medical',
        relationship: 'Self',
        ClaimAddress: '202 Insurance Ave',
        relationshipOther: 'Spouse',
      },
    }));
  };

  const printFormHandler = async () => {
    try {
      const response = await createPatientPdfApi(patientId);
      if (response.data?.pdf?.success) {
        toast.success('Patient form will be downloaded shortly');
        const bucketName = response.data.pdf.output_bucket_name;
        const key = response.data.pdf.output_key;
        try {
          const presignedUrl = await pollFileAvailability(
            checkFileAvailabilityApi,
            bucketName,
            key,
          );
          downloadFile(presignedUrl, patientId);
        } catch (error) {
          console.error('Failed to get presigned URL:', error);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleDeleteFile = async (file) => {
    try {
      console.log('File to delete:', file);
      await deleteFileApi('patient', patientId, file.id);
      setUploadedFiles(
        uploadedFiles.filter((data) => data.fileId !== file.fileId),
      );
      toast.success('File deleted successfully');
    } catch (err) {
      toast.error('Error deleting file');
    }
  };

  const downloadFile = async (presignedUrl, patientId) => {
    try {
      const response = await axios.get(presignedUrl, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${patientId}-patient_form.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading the file', error);
    }
  };

  return (
    <ProtectedComponent
      requiredPermission={
        permissionsWithAssignedIds[permissionsList.AddPatient]
      }
    >
      <div className="flex" style={{ alignItems: 'flex-start' }}>
        <div className="container-fluid" style={{ flex: '1 0 0' }}>
          <PageHeader
            HeaderText={isEditPatientForm ? 'Edit Patient' : 'Add Patient'}
            Breadcrumb={[
              { name: 'Patients', navigate: '/view-patients' },
              { name: 'View Patients', navigate: '/view-patients' },
              {
                name: isEditPatientForm ? 'Edit Patient' : 'Add Patient',
                navigate: isEditPatientForm
                  ? `/patient/${patientId}/edit`
                  : '/patient-form',
              },
            ]}
          />
        </div>
        <div
          style={{
            textAlign: 'center',
            marginTop: '20px',
            marginRight: '20px',
          }}
        >
          <button
            className="btn btn-primary"
            onClick={
              patientRegistered && !isEditPatientForm
                ? handleSubmit
                : handlePatientRegister
            }
            // disabled={!patientRegistered && isSubmitDisabled }
            // disabled={ !isFormValid() }
          >
            {patientRegistered && !isEditPatientForm
              ? 'Submit'
              : patientId && isEditPatientForm
                ? 'Update'
                : 'Submit'}
          </button>
          {/* <button
            className="btn btn-secondary"
            onClick={prefillForm}
            style={{ marginLeft: '10px' }}
          >
            Prefill Form
          </button> */}
          {isEditPatientForm ? (
            <button
              className="btn btn-danger"
              onClick={printFormHandler}
              style={{ marginLeft: '10px' }}
            >
              Print Form
            </button>
          ) : null}
          <button
            className="btn btn-secondary"
            onClick={() => navigate('/view-patients')}
            style={{ marginLeft: '10px' }}
          >
            Cancel
          </button>
        </div>
      </div>
      <div className="theme-blush component-wrapper">
        <div className="registration-vertical-align-wrap">
          <div className="vertical-align-middle registration-form">
            <div style={{ padding: '15px' }}>
              {/* <div className="top">
                <img
                  src={Logo}
                  alt="Blomboss Logo"
                  style={{ width: '150px', margin: '10px' }}
                />
              </div> */}
              <form>
                <div>
                  {/* Allow user to specify custom patient id while creating a new user  */}
                  {!isEditPatientForm && (
                    <div className="card">
                      <div className="header">
                        <p className="lead">Specify Custom patient id</p>
                      </div>
                      <div className="body">
                        <div
                          className="row clearfix"
                          style={{ alignItems: 'baseline' }}
                        >
                          <div className="col-md-4">
                            <input
                              className="form-control"
                              placeholder="Custom Patient ID"
                              disabled={!useCustomPatientId}
                              value={patientFormData.customPatientId}
                              onChange={(e) => {
                                setPatientFormData({
                                  ...patientFormData,
                                  customPatientId: e.target.value,
                                });
                              }}
                            />
                            {submeet && useCustomPatientId && (
                              <ul
                                className="parsley-errors-list filled"
                                id="parsley-id-29"
                              >
                                <li className="parsley-required">
                                  This value is required.
                                </li>
                              </ul>
                            )}
                          </div>
                          <div className="col-md-4">
                            <input
                              type="checkbox"
                              id="useCustomPatientId"
                              checked={useCustomPatientId}
                              onChange={(e) => {
                                setUseCustomPatientId(e.target.checked);
                              }}
                            />
                            <label
                              className="ml-1"
                              htmlFor="useCustomPatientId"
                            >
                              Use Custom Patient ID
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <BasicDetails
                    patientFormData={patientFormData}
                    setPatientFormData={setPatientFormData}
                    submeet={submeet}
                    isEditPatientForm={isEditPatientForm}
                    validateField={validateField}
                    validateExactLength={validateExactLength}
                    validateIsNumber={validateIsNumber}
                    validateEmail={validateEmail}
                    validatePhoneNumber={validatePhoneNumber}
                    touchedFields={touchedFields}
                    setTouchedFields={setTouchedFields}
                  />
                  {/* <GuarantorInformation
                      patientFormData={patientFormData}
                      setPatientFormData={setPatientFormData}
                      submeet={submeet}
                    /> */}
                  <PartnerInformationForm
                    patientFormData={patientFormData}
                    setPatientFormData={setPatientFormData}
                    submeet={submeet}
                    validateField={validateField}
                    validateExactLength={validateExactLength}
                    validateIsNumber={validateIsNumber}
                    validateEmail={validateEmail}
                    validatePhoneNumber={validatePhoneNumber}
                    touchedFields={touchedFields}
                    setTouchedFields={setTouchedFields}
                  />
                  <MedicalReferralInformation
                    patientFormData={patientFormData}
                    setPatientFormData={setPatientFormData}
                    submeet={submeet}
                  />
                  <InsuranceDetailsForm
                    patientFormData={patientFormData}
                    setPatientFormData={setPatientFormData}
                    submeet={submeet}
                  />
                </div>
              </form>
            </div>

            {isEditPatientForm && (
              <div className="card">
                <div className="header">
                  <p className="lead">Patient Files</p>
                </div>

                <div>
                  <div className="row clearfix">
                    <FileUploadCard
                      setFiles={setFiles}
                      setUploadedFiles={setUploadedFiles}
                      files={uploadedFiles}
                      handleUpload={handleUpload}
                      id={patientId}
                    />
                    {uploadedFiles.map((data, i) => {
                      console.log('uploadedFiles', uploadedFiles);
                      return (
                        <FileDocumentCard
                          key={i}
                          DocumentName={data.displayFileName}
                          DocumentSize={(data.size / 1024).toFixed(2) + ' KB'}
                          DocumentDate={new Date(
                            data.updatedAt,
                          ).toLocaleDateString()}
                          ImageUrl={
                            data?.fileType?.includes('image')
                              ? data.presignedUrl
                              : undefined
                          }
                          handleDeleteFile={() => handleDeleteFile(data)}
                          file={data}
                          fileUniquePrefix={`patient-${patientId}`}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {loading && (
          <LoadingOverlay
            message={`${loadingText ? loadingText : 'Processing'}`}
          />
        )}
      </div>
    </ProtectedComponent>
  );
};

const mapStateToProps = ({ loginReducer }) => ({
  email: loginReducer.email,
  password: loginReducer.password,
});

export default connect(mapStateToProps, {})(RegistrationForm);
